import { App as CapApp } from '@capacitor/app';
import { isNative } from './capacitor';

/**
 * Register the Android hardware back-button handler.
 * `onBack` receives { canGoBack } and must decide whether to navigate or exit.
 * On web this is a no-op — rely on the browser's built-in behaviour.
 */
export function registerBackHandler(onBack) {
  if (!isNative()) return () => {};

  const listener = CapApp.addListener('backButton', onBack);
  return () => listener.then((l) => l.remove());
}

export async function exitApp() {
  if (!isNative()) return;
  await CapApp.exitApp();
}
